module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar d-flex align-items-end relative"
  }, [_c('img', {
    staticClass: "smallLogo",
    attrs: {
      "src": "/static/images/common/logo_small_red_white.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/auth/login.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "fs-largest lightest headline"
  }, [_vm._v("\"We can turn our effort into creating better experiences to our customers.\"")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small dark"
  }, [_vm._v("No booking fees for unlimited products and unlimited agents.")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-abc82e8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abc82e8c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/sidebars/LoginSidebar.vue
// module id = 1218
// module chunks = 0